// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1332":"4fd7340c","2352":"b292d3eb","4338":"474c57c0","8536":"b5539a7b","9352":"4fd7340c"}[chunkId] + ".chunk.css";
};